"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[60367],{

/***/ 993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ButtonIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyleIconButton = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].button([
  ({ theme, loading, color, activeColor, size, backgroundColor, isMobile }) => `
  all: unset;
  color: ${loading ? theme.colors[activeColor] || activeColor : theme.colors[color] || color};
  position: relative;
  cursor: pointer;
  width: ${size}px;
  height: ${size}px;
  padding: 5px;
  border-radius: 9999px;
  box-sizing: content-box;
  text-align: center;
  display:inline-flex;
  box-shadow: 1px ${theme.colors[backgroundColor] || backgroundColor};
  outline: none;
  &:focus,&:active,&:hover {
    border: none!important;
    outline: none!important;
    box-shadow: none !important;
  };

  ${!isMobile && `&:hover,&:active {
      background-color: ${theme.colors.background};
      color: ${theme.colors[activeColor] || activeColor};
    };`}
  ${loading ? `
    background-color: ${theme.colors.background} !important;
    &::after {
      content:"";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left:0;
      margin: auto;
      animation: spinner 1s linear infinite;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      box-shadow: 0 1px 0 0 ${theme.colors[activeColor] || activeColor};
      box-sizing: content-box;
    };` : ""}

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  };`,
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F
]);
const ButtonIcon = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyleIconButton, __spreadValues({}, props), (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, __spreadProps(__spreadValues({}, children.props), {
    size: props.size,
    color: "currentColor"
  })));
};
ButtonIcon.defaultProps = {
  activeColor: "primary",
  color: "textSecondary"
};




/***/ }),

/***/ 248169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InputNumber; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var rc_input_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(241305);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(994734);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(925810);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(978719);
/* harmony import */ var _contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(263008);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SAVED_DECIMAL_SEPARATOR = ".";
const InputNumber = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    size: customizeSize,
    addonBefore,
    addonAfter,
    bordered = true,
    disabled = false,
    readOnly = false,
    formatter,
    parser
  } = _b, props = __objRest(_b, [
    "size",
    "addonBefore",
    "addonAfter",
    "bordered",
    "disabled",
    "readOnly",
    "formatter",
    "parser"
  ]);
  var _a2, _b2;
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SizeContext */ .X);
  const mergeSize = customizeSize || size || "m";
  const { decimalSeparator } = props;
  const defaultFormatter = (value) => {
    if (!value)
      return "";
    if (typeof value === "string") {
      value = parseFloat(value);
    }
    const locale = decimalSeparator === "." ? "en-CA" : "de-DE";
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: 10
    }).format(value);
  };
  const defaultParser = (value) => {
    if (!value) {
      return "";
    }
    const thousandSeparator = decimalSeparator === "." ? "," : ".";
    return value.replace(thousandSeparator, "").replace(decimalSeparator || ".", SAVED_DECIMAL_SEPARATOR);
  };
  const prefix = addonBefore ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize]
  }, typeof addonBefore === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonBefore) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonBefore, {
    size: ((_a2 = addonBefore == null ? void 0 : addonBefore.props) == null ? void 0 : _a2.size) || 20
  })) : null;
  const suffix = addonAfter ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginLeft: "s16"
  }, typeof addonAfter === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonAfter) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonAfter, {
    size: ((_b2 = addonAfter == null ? void 0 : addonAfter.props) == null ? void 0 : _b2.size) || 20
  })) : null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    disabled,
    readOnly,
    bordered,
    paddingRight: !!suffix ? "s16" : "s0",
    className: "wrap-input-number"
  }, prefix, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rc_input_number__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, __spreadValues({
    ref,
    upHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .UpOutlined */ .X, {
      size: 12
    }),
    downHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .DownOutlined */ .T, {
      size: 12
    }),
    disabled,
    readOnly,
    formatter: formatter != null ? formatter : defaultFormatter,
    parser: parser != null ? parser : defaultParser
  }, props)), suffix);
});
InputNumber.displayName = "InputNumber";
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)(({ theme, disabled, readOnly, bordered }) => `
  ${disabled ? `background: ${theme == null ? void 0 : theme.colors.background}; 
         cursor: not-allowed;` : "background: white;"}
  ${bordered ? `border: 1px solid ${theme == null ? void 0 : theme.colors.border};
         border-radius: 4px;` : ""}
  &:focus-within{
    border-color: ${theme == null ? void 0 : theme.colors.link500};
  }
  display: flex;
  padding-left: 0.75rem;
  .rc-input-number {
      position: relative;
      flex: 1;
      padding: 0 1px;
      &:hover{
        .rc-input-number-handler-wrap{
            opacity: 1;
        }
      }
  }
  .rc-input-number-input-wrap{
      height: 100%;
      & input {
        width: 100%;
        height: 100%;
        outline: 0;
        border: 0;
        &::placeholder {
          color: ${theme == null ? void 0 : theme.colors.placeholder};
        }
        ${disabled ? "cursor: not-allowed;" : ""}
    }
  }
  .rc-input-number-handler-wrap{
      opacity: 0;
      transition: opacity 0.24s linear 0.1s;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      right: 0;
      line-height: 0;
      height: 100%;
      width: 25px;
      ${bordered ? `border-left: 1px solid ${theme == null ? void 0 : theme.colors.border};
             border-right: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
      ${disabled || readOnly ? "display: none;" : ""}
  }
  .rc-input-number-handler-up, 
  .rc-input-number-handler-down{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.link500};
    }
  }
  .rc-input-number-handler-down {
    ${bordered ? `border-top: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
  }
  .rc-input-number-handler-up-disabled, 
  .rc-input-number-handler-down-disabled {
    cursor: not-allowed;
    background: ${theme == null ? void 0 : theme.colors.background};
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
  }
`);
const StyledSpace = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  align-items: center;
`;




/***/ }),

/***/ 280392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(978719);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(957518);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(873834);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(248169);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const QuantitySize = {
  xs: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s28 */ .y.s28,
    width: "5.75rem"
  },
  s: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s32 */ .y.s32,
    width: "6.375rem"
  },
  m: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s40 */ .y.s40,
    width: "6.375rem"
  }
};
const QuantityWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f;
  return [
    _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F,
    `
  height: ${QuantitySize[props.size || "m"].height};
  width: ${props.block ? "100%" : QuantitySize[props.size || "m"].width};
  border-radius: ${(_a = props.theme) == null ? void 0 : _a.borderRadius.s};
  background: ${props.disabled ? (_b = props.theme) == null ? void 0 : _b.colors.background : (_c = props.theme) == null ? void 0 : _c.colors.tableHeader};
  ${!props.disabled ? `border: ${(_d = props.theme) == null ? void 0 : _d.borderWeight.m} solid ${((_e = props.theme) == null ? void 0 : _e.colors[props.color]) || ((_f = props.theme) == null ? void 0 : _f.colors.divider)};` : ""}
  display: flex;
  align-items: center;
  overflow: hidden;
`
  ];
});
const Plus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const Minus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const InputWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ color, theme }) => `
  flex: 1;
  .wrap-input-number {
    padding: 0;
    border: none;
    background-color: transparent;
  }
  .wrap-input-number input {
    text-align: center;
    background-color: transparent;
    font-size: 0.8125rem;
    font-weight: 500;
    color: ${color ? (theme == null ? void 0 : theme.colors[color]) || color : "rgb(67, 70, 87)"};
  }
`);
const IconButonWapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  display: inline-flex;
  align-items: center;
`;
const Quantity = (_a) => {
  var _b = _a, {
    min = 1,
    max = 999,
    quantity = 1,
    precision,
    decimalSeparator = ",",
    step = 1,
    size = "s",
    disabled,
    disableInput,
    disableMinus,
    disablePlus,
    className,
    onMinus,
    onPlus,
    setQuantity,
    color,
    block,
    blurOnEnter = false,
    formatter,
    parser
  } = _b, rest = __objRest(_b, [
    "min",
    "max",
    "quantity",
    "precision",
    "decimalSeparator",
    "step",
    "size",
    "disabled",
    "disableInput",
    "disableMinus",
    "disablePlus",
    "className",
    "onMinus",
    "onPlus",
    "setQuantity",
    "color",
    "block",
    "blurOnEnter",
    "formatter",
    "parser"
  ]);
  const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const onChange = (val) => {
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    if (typeof val !== "number") {
      return;
    }
    setQuantity == null ? void 0 : setQuantity(val);
  };
  const onDecrease = () => {
    if (onMinus) {
      onMinus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity - step);
    }
  };
  const onIncrease = () => {
    if (onPlus) {
      onPlus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity + step);
    }
  };
  const disableMinusButton = disabled || disableMinus || quantity - step < min;
  const disablePlusButton = disabled || disablePlus || quantity + step > max;
  const disableInputField = disabled || disableInput;
  const handleBlurOnEnter = (e) => {
    var _a2;
    const ENTER_CHAR_CODE = 13;
    if (e.charCode === ENTER_CHAR_CODE) {
      (_a2 = inputRef.current) == null ? void 0 : _a2.blur();
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const current = inputRef.current;
    if (blurOnEnter) {
      current == null ? void 0 : current.addEventListener("keypress", handleBlurOnEnter);
    }
    return () => {
      current == null ? void 0 : current.removeEventListener("keypress", handleBlurOnEnter);
    };
  }, [blurOnEnter]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QuantityWrapper, __spreadValues({
    className,
    size,
    block,
    disabled,
    color,
    onClick: (e) => e.preventDefault()
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Minus, {
    className: "minus-btn",
    disabled: disableMinusButton,
    onClick: onDecrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .MinusOutlined */ .l, {
    color: disableMinusButton ? "disable" : color || "textPrimary",
    size: 16
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputWrapper, {
    className: "quantity-input-wrapper",
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__/* .InputNumber */ .R, {
    ref: inputRef,
    value: quantity,
    onFocus: (event) => event.target.select(),
    onChange,
    disabled: disableInputField,
    controls: false,
    min,
    max,
    step,
    precision,
    decimalSeparator,
    formatter,
    parser
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Plus, {
    className: "plus-btn",
    disabled: disablePlusButton,
    onClick: onIncrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .AddOutlined */ .v, {
    color: disablePlusButton ? "disable" : color || "textPrimary",
    size: 16
  }))));
};




/***/ }),

/***/ 873834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ AddOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const AddOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H11.25V20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20V12.75H20C20.4142 12.75 20.75 12.4142 20.75 12C20.75 11.5858 20.4142 11.25 20 11.25H12.75V4Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 925810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ DownOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DownOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5 8.5L12 15.5L19 8.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 276362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ShoppingCartOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShoppingCartOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 3.75C3 3.33579 3.33579 3 3.75 3H6.00033C6.41455 3 6.75033 3.33579 6.75033 3.75V6.00035H18.7522C18.9832 6.00035 19.2012 6.10676 19.3434 6.28879C19.4855 6.47083 19.5358 6.7082 19.4798 6.93225L17.9796 12.9331C17.8961 13.267 17.5961 13.5012 17.252 13.5012H6.75033V14.2516C6.75033 14.4505 6.82937 14.6413 6.97007 14.782C7.11076 14.9227 7.30158 15.0018 7.50055 15.0018H19.5023C19.9165 15.0018 20.2523 15.3376 20.2523 15.7518C20.2523 16.166 19.9165 16.5018 19.5023 16.5018H7.50055C6.90376 16.5018 6.33141 16.2647 5.90941 15.8427C5.48741 15.4207 5.25033 14.8483 5.25033 14.2516V12.7544C5.25033 12.7534 5.25033 12.7523 5.25033 12.7512C5.25033 12.7502 5.25033 12.7491 5.25033 12.748V6.75355C5.25033 6.75249 5.25033 6.75142 5.25033 6.75035C5.25033 6.74929 5.25033 6.74822 5.25033 6.74715V4.5H3.75C3.33579 4.5 3 4.16421 3 3.75ZM6.75033 7.50035V12.0012H16.6664L17.7916 7.50035H6.75033ZM6.0006 19.5024C6.0006 18.6739 6.67222 18.0023 7.50071 18.0023C8.3292 18.0023 9.00082 18.6739 9.00082 19.5024C9.00082 20.3309 8.3292 21.0025 7.50071 21.0025C6.67222 21.0025 6.0006 20.3309 6.0006 19.5024ZM18.0021 18.0023C17.1736 18.0023 16.502 18.6739 16.502 19.5024C16.502 20.3309 17.1736 21.0025 18.0021 21.0025C18.8306 21.0025 19.5022 20.3309 19.5022 19.5024C19.5022 18.6739 18.8306 18.0023 18.0021 18.0023Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 994734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ UpOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UpOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19 15.5L12 8.5L5 15.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 675601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  if (serverless) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href: href || "",
    as
  }, rest), {
    prefetch
  }), children);
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  color: black;
  text-decoration: none;
`;




/***/ }),

/***/ 875547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ok": function() { return /* binding */ SOURCE_VIDEO; },
/* harmony export */   "bM": function() { return /* binding */ defaultSlider; },
/* harmony export */   "n6": function() { return /* binding */ DEFAULT_NUMBER_DISPLAY_FORMAT; }
/* harmony export */ });
const defaultSlider = {
  perView: 5,
  perSwipe: "|",
  autoplay: 0
};
const DEFAULT_NUMBER_DISPLAY_FORMAT = {
  thousandSeparator: ".",
  decimalSeparator: ","
};
var SOURCE_VIDEO = /* @__PURE__ */ ((SOURCE_VIDEO2) => {
  SOURCE_VIDEO2["SYSTEM"] = "SYSTEM";
  SOURCE_VIDEO2["YOUTUBE"] = "YOUTUBE";
  return SOURCE_VIDEO2;
})(SOURCE_VIDEO || {});




/***/ }),

/***/ 54230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V2": function() { return /* binding */ numberFormatter; },
/* harmony export */   "kX": function() { return /* binding */ numberParser; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(875547);


const formatCurrency = (value, numberDisplayFormat, includeUnit = true) => {
  if (typeof value !== "number")
    return "";
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  else
    currencyFormat = new Intl.NumberFormat("vi-VN");
  const valueWithCurrency = currencyFormat.format(value);
  if (!!numberDisplayFormat) {
    return valueWithCurrency.replaceAll(".", numberDisplayFormat.thousandSeparator);
  } else {
    return valueWithCurrency;
  }
};
const numberFormatter = (value, numberDisplayFormat) => {
  const strValue = String(value);
  const [integerPart, decimalPart = ""] = strValue.split(".");
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, (numberDisplayFormat == null ? void 0 : numberDisplayFormat.thousandSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.thousandSeparator */ .n6.thousandSeparator) + (strValue.includes(".") ? `${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}${decimalPart}` : "");
};
const numberParser = (value, numberDisplayFormat) => {
  return (numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) === "." ? `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "") : `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "").replace(`${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}`, ".");
};




/***/ }),

/***/ 589561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledInput = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input */ .Z.input`
  display: block;
  width: 100%;
  border-radius: 4px;
  padding: 0.375rem 0.75rem;
  border: 1px solid #e0e0e0;
  min-height: 16px;
  &:focus {
    outline: 0;
  }
  /* Chrome, Safari, Edge, Opera */
  &:-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
const Input = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadValues({}, props));




/***/ }),

/***/ 184117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SearchBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var _atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(589561);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(650983);
/* harmony import */ var _contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(580871);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledSearchBar = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme, tintColor, barStyle }) => {
  const bgColor = tintColor ? tintColor : theme.colors.gray100;
  const borderRadius = `var(--search-bar-border-radius ,8px)`;
  const styles = {
    display: "flex"
  };
  switch (barStyle) {
    case "nav":
      styles["backgroundColor"] = bgColor;
      styles["borderRadius"] = "8px";
      styles[".search-icon"] = {
        backgroundColor: "transparent",
        order: -1
      };
      styles[".search-input"] = {
        paddingLeft: 0
      };
      break;
    case "light": {
      styles["backgroundColor"] = "#f6f6f6";
      styles["borderRadius"] = "8px";
      styles[".search-icon"] = {
        backgroundColor: "transparent",
        order: -1
      };
      styles[".search-input"] = {
        paddingLeft: 0
      };
      break;
    }
    default:
      styles["backgroundColor"] = bgColor;
      styles.border = `1px solid ${bgColor}`;
      styles.padding = "1px";
      styles["borderRadius"] = borderRadius;
      styles["--button-icon-border-radius"] = borderRadius;
      break;
  }
  return styles;
});
const StyledInput = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .I)`
  border: 0;
  background-color: transparent;
  flex: 1;
  height: 100%;
`;
const SearchIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)`
  height: 36px;
  width: 36px;
  border-radius: 8px;
  padding: 0;
  justify-content: center;
  border: 0;
  background-color: transparent;
`;
const SearchIconWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  display: inline-block;
`;
const SearchBoxWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  display: inline-block;
  width: 100%;
`;
const SearchBar = (_a) => {
  var _b = _a, {
    placeholder,
    prepend,
    searchIconProps,
    tintColor,
    barStyle,
    className,
    onClickIcon,
    onClickInput,
    iconStyles
  } = _b, inputProps = __objRest(_b, [
    "placeholder",
    "prepend",
    "searchIconProps",
    "tintColor",
    "barStyle",
    "className",
    "onClickIcon",
    "onClickInput",
    "iconStyles"
  ]);
  const theme = (0,_contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSearchBar, {
    tintColor,
    barStyle,
    className
  }, prepend, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchBoxWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchBox"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadValues({
    className: "search-input",
    placeholder,
    onClick: onClickInput,
    role: "searchbox",
    "aria-label": "Search"
  }, inputProps))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchIconWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchButton"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchIcon, __spreadValues({
    onClick: onClickIcon,
    className: "search-icon",
    "aria-label": "Search",
    icon: __spreadValues({
      name: "search",
      size: 26,
      color: theme.colors.gray700
    }, iconStyles)
  }, searchIconProps))));
};




/***/ }),

/***/ 836282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(280392);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54230);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(284587);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(353632);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







const Quantity = (props)=>{
    const { numberDisplayFormat  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Quantity */ .h, _objectSpread({}, (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getEnv */ .dU)("EPIC_ECOM_489") === "enabled" ? {
        decimalSeparator: (numberDisplayFormat === null || numberDisplayFormat === void 0 ? void 0 : numberDisplayFormat.decimalSeparator) || constants_index__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator,
        formatter: (value)=>(0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .numberFormatter */ .V2)(value, numberDisplayFormat || constants_index__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_NUMBER_DISPLAY_FORMAT */ .n6),
        parser: (value)=>(0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .numberParser */ .kX)(value, numberDisplayFormat || constants_index__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_NUMBER_DISPLAY_FORMAT */ .n6)
    } : {}, props));
};


/***/ }),

/***/ 88002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ SearchBar; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/SearchBar/SearchBar.es.js
var SearchBar_es = __webpack_require__(184117);
// EXTERNAL MODULE: ./hooks/useSearchSuggestions.tsx
var useSearchSuggestions = __webpack_require__(545719);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/PopularKeywordContext.tsx
var PopularKeywordContext = __webpack_require__(868673);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/Text/Text.es.js
var Text_es = __webpack_require__(327513);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
;// CONCATENATED MODULE: ./components/desktop/organisms/RecommendedKeyword.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 8px 0 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding-top: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  background: #fff;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  height: 32px;\n  line-height: 32px;\n  padding: 0 16px;\n  border-radius: 999px;\n  background: #f5f5f5;\n  color: #333;\n  margin: 0 4px 10px 4px;\n  font-size: 14px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #ececec;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






const StyledSearchTitle = styled_es/* styled.div */.z.div(_templateObject());
const StyledRecommendedKeyword = styled_es/* styled.div */.z.div(_templateObject1());
const RecommendedKeywordWrapper = styled_es/* styled.div */.z.div(_templateObject2());
const RecommendedKeywordItem = styled_es/* styled.div */.z.div(_templateObject3());
const RecommendedKeyword = (param)=>{
    let { popularKeywords , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRecommendedKeyword, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                    fontWeight: "500",
                    textTransform: "uppercase",
                    color: "#82869E",
                    children: (0,i18n.t)("Từ kh\xf3a phổ biến")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeywordWrapper, {
                children: popularKeywords === null || popularKeywords === void 0 ? void 0 : popularKeywords.map((term, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeywordItem, _objectSpreadProps(_objectSpread({
                        onClick: ()=>onClick(term)
                    }, (0,helper_es/* getTrackingData */.O5)({
                        isTrackContent: true,
                        regionName: "popularKeyword",
                        contentName: term,
                        target: "searchProductResult",
                        payload: JSON.stringify({
                            screenName: "searchProduct",
                            index
                        })
                    })), {
                        children: term
                    }), index);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/SvgIcon.es.js
var SvgIcon_es = __webpack_require__(46610);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchRecent.tsx
function SearchRecent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchRecent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchRecent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchRecent_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SearchRecent_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SearchRecent_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SearchRecent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchRecent_templateObject() {
    const data = SearchRecent_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n"
    ]);
    SearchRecent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchRecent_templateObject1() {
    const data = SearchRecent_taggedTemplateLiteral([
        "\n  min-width: 20px;\n"
    ]);
    SearchRecent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const SearchRecent_StyledSearchTitle = styled_es/* styled.div */.z.div(SearchRecent_templateObject());
const StyledSearchItem = styled_es/* styled.div */.z.div((props)=>"\n  display: flex;\n  padding: 0.6rem;\n  cursor: pointer;\n  background: ".concat(props.selected ? "#f5f5f5" : "#fff", ";\n  border-radius: 8px;\n"));
const StyledRemoveHistory = styled_es/* styled.div */.z.div((props)=>{
    var ref;
    return "\n  cursor: pointer;\n  color: #848788;\n  &:hover {\n    color: ".concat((ref = props.theme) === null || ref === void 0 ? void 0 : ref.colors.primary, ";\n  }\n");
});
const StyledIcon = (0,styled_es/* styled */.z)(SvgIcon_es/* SvgIcon */.l)(SearchRecent_templateObject1());
const SearchRecent = (param)=>{
    let { histories , onRemoveSearchHistories , onSearch , selected , onHoverItem  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchRecent_StyledSearchTitle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                        fontWeight: "500",
                        textTransform: "uppercase",
                        color: "#82869E",
                        children: (0,i18n.t)("Lịch sử t\xecm kiếm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRemoveHistory, SearchRecent_objectSpreadProps(SearchRecent_objectSpread({
                        onClick: onRemoveSearchHistories
                    }, (0,helper_es/* getTrackingData */.O5)({
                        isTrackContent: true,
                        regionName: "recentSearch",
                        contentName: "clearHistorySearch",
                        target: "searchProduct"
                    })), {
                        children: (0,i18n.t)("X\xf3a lịch sử")
                    }))
                ]
            }),
            histories === null || histories === void 0 ? void 0 : histories.filter((history)=>!!history).map((history, index)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(StyledSearchItem, SearchRecent_objectSpreadProps(SearchRecent_objectSpread({
                    onClick: ()=>onSearch(history),
                    selected: index === selected,
                    onMouseEnter: ()=>onHoverItem(index)
                }, (0,helper_es/* getTrackingData */.O5)({
                    isTrackContent: true,
                    regionName: "recentSearch",
                    contentName: history === null || history === void 0 ? void 0 : history.query,
                    target: "searchProductResult",
                    payload: JSON.stringify({
                        screenName: "searchProduct",
                        index
                    })
                })), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "time-outline",
                            size: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                margin: "0 0.6rem"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                                maxLines: 1,
                                children: history === null || history === void 0 ? void 0 : history.query
                            })
                        })
                    ]
                }), index);
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Popover/Tooltip.es.js
var Tooltip_es = __webpack_require__(386877);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/ButtonIcon/ButtonIcon.es.js
var ButtonIcon_es = __webpack_require__(993);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/SearchOutlined.es.js
var SearchOutlined_es = __webpack_require__(877936);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ShoppingCartOutlined.es.js
var ShoppingCartOutlined_es = __webpack_require__(276362);
// EXTERNAL MODULE: ./components/Quantity.tsx
var Quantity = __webpack_require__(836282);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchList.tsx
function SearchList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchList_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SearchList_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SearchList_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SearchList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchList_templateObject() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  text-overflow: ellipsis;\n"
    ]);
    SearchList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchList_templateObject1() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  flex: 1;\n  overflow: hidden;\n"
    ]);
    SearchList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchList_templateObject2() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  min-width: 50px;\n  width: 50px;\n  position: relative;\n"
    ]);
    SearchList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








const SearchList_StyledSearchItem = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)((props)=>"\n  display: flex;\n  padding: 0.6rem;\n  cursor: pointer;\n  border-radius: 8px;\n  align-items: center;\n  justify-content: ".concat(props.isSuggestProduct ? "space-between" : "none", " ;\n  background: ").concat(props.selected ? "#f5f5f5" : "#fff", ";\n  border-bottom: 1px solid #f4f4f4;\n"));
const StyledTextSuggestion = (0,emotion_styled_browser_esm["default"])(index_es/* SubTitle */.DK)(SearchList_templateObject());
const SearchList = (param)=>{
    let { suggestions , onSearch , onHoverItem , selected , onAddToCart , onRedirectDetailProduct , isSuggestProduct =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: suggestions.map((suggestion, index)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(SearchList_StyledSearchItem, SearchList_objectSpreadProps(SearchList_objectSpread({
                onClick: ()=>!isSuggestProduct ? onSearch(suggestion) : onRedirectDetailProduct(suggestion.sku),
                selected: index === selected,
                onMouseEnter: ()=>onHoverItem(index),
                isSuggestProduct: isSuggestProduct
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "searchSuggestion",
                contentName: suggestion.query,
                target: "searchProductResult",
                payload: JSON.stringify({
                    screenName: "searchProduct",
                    index
                })
            })), {
                children: [
                    isSuggestProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSuggestItem, {
                        product: suggestion,
                        onAddToCart: onAddToCart
                    }),
                    !isSuggestProduct && !!(suggestion === null || suggestion === void 0 ? void 0 : suggestion.query) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined_es/* SearchOutlined */.l, {
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    margin: "0 0.6rem"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, {
                                    level: 2,
                                    line: 1,
                                    weight: "regular",
                                    children: suggestion.query
                                })
                            })
                        ]
                    })
                ]
            }), index);
        })
    });
};
const ProductInfoWrapper = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(SearchList_templateObject1());
const ProductImageWrapper = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)(SearchList_templateObject2());
/** trust parent is flex */ const ProductSuggestItem = (param)=>{
    let { product , onAddToCart  } = param;
    const { imageUrl , highlight , uomName  } = product;
    const { 0: quantity , 1: setQuantity  } = (0,react.useState)(1);
    const { isDisplayUom  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfoWrapper, {
                gapX: "s16",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            aspectRatio: 1,
                            contain: true,
                            src: imageUrl || "",
                            alt: highlight,
                            borderRadius: 5
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shape_index_es/* Shape */.b, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_es/* Tooltip */.u, {
                                title: highlight || "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextSuggestion, {
                                    level: 2,
                                    line: 1,
                                    weight: "regular",
                                    children: highlight
                                })
                            }),
                            isDisplayUom && !!uomName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                                color: "textSecondary",
                                level: 1,
                                children: [
                                    (0,i18n.t)("Đơn vị t\xednh:"),
                                    " ",
                                    uomName
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                gap: "s16",
                align: "center",
                gapX: "s36",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity/* Quantity */.h, {
                        quantity: quantity,
                        setQuantity: setQuantity,
                        onClick: (e)=>{
                            e.stopPropagation && e.stopPropagation();
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_es/* Tooltip */.u, {
                        title: (0,i18n.t)("Th\xeam v\xe0o giỏ h\xe0ng"),
                        placement: "bottom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon_es/* ButtonIcon */.E, {
                            size: 30,
                            color: "primary",
                            onClick: (e)=>{
                                onAddToCart(product, quantity);
                                e.stopPropagation && e.stopPropagation();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartOutlined_es/* ShoppingCartOutlined */.O, {})
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./constants/local.ts
var local = __webpack_require__(479228);
// EXTERNAL MODULE: ../../packages/tracking/dist/cart.es.js
var cart_es = __webpack_require__(446586);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(348855);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchBar.tsx
function SearchBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchBar_templateObject() {
    const data = SearchBar_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    SearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchBar_templateObject1() {
    const data = SearchBar_taggedTemplateLiteral([
        "\n  ",
        "\n  border: 1px solid #eaeaea;\n"
    ]);
    SearchBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchBar_templateObject2() {
    const data = SearchBar_taggedTemplateLiteral([
        "\n  position: absolute;\n  background: #fff;\n  width: 120%;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);\n  padding: 0.5rem 0.8rem;\n  z-index: 1000;\n  display: ",
        ";\n"
    ]);
    SearchBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













const SearchBarWrapper = emotion_styled_browser_esm["default"].div(SearchBar_templateObject());
const StyledSearchBar = (0,emotion_styled_browser_esm["default"])(SearchBar_es/* SearchBar */.E)(SearchBar_templateObject1(), (param)=>{
    let { displayNewLayout , searchIconBackgroundColor  } = param;
    return "".concat(!!displayNewLayout ? "border-radius: calc(infinity * 1px);\n          .search-icon {\n            background-color: ".concat(searchIconBackgroundColor, ";\n            border-radius: calc(infinity * 1px);\n            height: 32px;\n            width: 32px;\n            margin: 2px;\n          }") : "");
});
const SearchSuggestion = emotion_styled_browser_esm["default"].div(SearchBar_templateObject2(), (props)=>props.show ? "block" : "none");
const SearchBar = ()=>{
    const router = (0,next_router.useRouter)();
    const { 0: visible , 1: setVisible  } = (0,react.useState)(false);
    const { 0: selectedSuggestion , 1: setSelectedSuggestion  } = (0,react.useState)(null);
    const { keyword , setKeyword , histories , suggestions , removeSearchHistories , onSearch , isSuggestProduct , onRedirectDetailProduct , addToCart ,  } = (0,useSearchSuggestions/* useSearchSuggestions */.f)();
    const { displayNewLayout  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { terms , setStartCallApi  } = (0,PopularKeywordContext/* usePopularKeyword */.y)();
    const { colors  } = (0,Theme_es/* useTheme */.F)();
    const { 0: input , 1: setInput  } = (0,react.useState)(keyword || "");
    const showHistories = !(keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && histories.length > 0;
    const showSuggestions = (keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && suggestions.length > 0;
    const showRecommendedKeywords = !(keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && terms.length > 0;
    const handleSearch = (keywordObj)=>{
        onSearch(keywordObj);
        setVisible(false);
    };
    const onKeyUp = (e)=>{
        if (e.keyCode === 13) {
            if (!visible || selectedSuggestion === null) {
                !!(input === null || input === void 0 ? void 0 : input.trim()) && handleSearch({
                    query: input.trim()
                });
                return;
            }
            if (showHistories || showSuggestions && !isSuggestProduct) {
                const searchParam = showHistories ? histories[selectedSuggestion] : suggestions[selectedSuggestion];
                handleSearch(searchParam);
                return;
            }
            if (showSuggestions && isSuggestProduct) {
                var ref;
                onRedirectDetailProduct((ref = suggestions[selectedSuggestion]) === null || ref === void 0 ? void 0 : ref.sku);
                return;
            }
        }
    };
    const handleNavigateSearchResult = (ev)=>{
        if (visible && (ev.keyCode === local/* ARROW_KEY_UP */.rw || ev.keyCode === local/* ARROW_KEY_DOWN */.sf)) {
            ev.preventDefault();
            if (!showSuggestions && !showHistories) return;
            const currentList = showHistories ? histories : suggestions;
            const length = currentList.length;
            if (selectedSuggestion === null) {
                setSelectedSuggestion(0);
                setInput(currentList[0].query || "");
            } else {
                if (ev.keyCode === local/* ARROW_KEY_UP */.rw) {
                    if (selectedSuggestion <= 0) {
                        setSelectedSuggestion(length - 1);
                        setInput(currentList[length - 1].query || "");
                    } else {
                        setSelectedSuggestion((prev)=>{
                            if (prev === null) return null;
                            setInput(currentList[prev - 1].query || "");
                            return prev - 1;
                        });
                    }
                } else if (ev.keyCode === local/* ARROW_KEY_DOWN */.sf) {
                    if (selectedSuggestion >= length - 1) {
                        setSelectedSuggestion(0);
                        setInput(currentList[0].query || "");
                    } else {
                        setSelectedSuggestion((prev)=>{
                            if (prev === null) return null;
                            setInput(currentList[prev + 1].query || "");
                            return prev + 1;
                        });
                    }
                }
            }
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const k = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.query) === null || ref1 === void 0 ? void 0 : ref1.toString();
        setSelectedSuggestion(null);
        const inputKeyword = k || "";
        setInput(inputKeyword);
        setKeyword(inputKeyword);
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
        onMouseLeave: ()=>setVisible(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchBar, {
                onChange: (e)=>{
                    if (!visible) setVisible(true);
                    setSelectedSuggestion(null);
                    setInput(e.target.value);
                    setKeyword(e.target.value);
                },
                onKeyUp: onKeyUp,
                onClickInput: ()=>{
                    (0,cart_es/* trackManually */.gu)("searchBox", "headerBar", "searchProduct", JSON.stringify(SearchBar_objectSpread({
                        searchKeyword: input ? input.trim() : ""
                    },  true ? {
                        href: window.location.href,
                        url: window.location.href
                    } : 0)));
                    setVisible(true);
                    setStartCallApi(true);
                },
                value: input,
                placeholder: (0,i18n.t)("Bạn muốn mua g\xec h\xf4m nay..."),
                onClickIcon: ()=>input && input.trim() && handleSearch({
                        query: input
                    }),
                onKeyDown: handleNavigateSearchResult,
                tintColor: "white",
                displayNewLayout: displayNewLayout,
                searchIconBackgroundColor: colors.primary,
                iconStyles: {
                    color: "white"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSuggestion, {
                show: visible && (showHistories || showSuggestions || showRecommendedKeywords),
                children: [
                    showHistories && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchRecent, {
                        selected: selectedSuggestion,
                        histories: histories,
                        onRemoveSearchHistories: removeSearchHistories,
                        onSearch: handleSearch,
                        onHoverItem: setSelectedSuggestion
                    }),
                    showSuggestions && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList, {
                        suggestions: suggestions,
                        onRedirectDetailProduct: onRedirectDetailProduct,
                        onHoverItem: setSelectedSuggestion,
                        selected: selectedSuggestion,
                        onAddToCart: addToCart,
                        onSearch: handleSearch,
                        isSuggestProduct: isSuggestProduct
                    }),
                    showRecommendedKeywords && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeyword, {
                        onClick: (k)=>handleSearch({
                                query: k
                            }),
                        popularKeywords: terms
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 228576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useSearchAlgo; }
/* harmony export */ });
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(185081);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(353632);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(788813);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(504133);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);





// hook use mainly for A/B testing new discovery search algorithm
const useSearchAlgo = ()=>{
    const { enableSearchAlgoABTesting  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const noDefaultSortOption = (0,helpers__WEBPACK_IMPORTED_MODULE_3__/* .getEnv */ .dU)("SEARCH_ALGO_NO_DEFAULT_SORT_OPTION") || "";
    const getSearchAlgoFromCookie = ()=>{
        var ref;
        return (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .isServerless */ .ep)() && !!enableSearchAlgoABTesting && !(0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .checkCurrentPageIsExcluded */ .RN)(router.pathname) ? (ref = (0,helpers__WEBPACK_IMPORTED_MODULE_3__/* .getCookieByName */ .A7)(constants_index__WEBPACK_IMPORTED_MODULE_6__/* .SEARCH_ALGO.COOKIE */ .XH.COOKIE)) === null || ref === void 0 ? void 0 : ref.replace(constants_index__WEBPACK_IMPORTED_MODULE_6__/* .SEARCH_ALGO.REPLACE_PATTERN */ .XH.REPLACE_PATTERN, "") : undefined;
    };
    const noActiveDefaultSortOption = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return noDefaultSortOption === "enabled" && !(0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .checkCurrentPageIsExcluded */ .RN)(router.pathname);
    }, [
        noDefaultSortOption,
        router.pathname
    ]);
    const getDefaultSortOption = (defaultSortOptionCode)=>{
        return !!noActiveDefaultSortOption ? undefined : defaultSortOptionCode;
    };
    return {
        noActiveDefaultSortOption,
        getSearchAlgoFromCookie,
        getDefaultSortOption
    };
};


/***/ }),

/***/ 545719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useSearchSuggestions; }
/* harmony export */ });
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(967438);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(446586);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(679376);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(185081);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(534090);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(964590);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(321708);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(querystring__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _useSearchAlgo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(228576);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









const useSearchSuggestions = function() {
    let { numberOfHistories =5 , limitKeywords  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isMobile , keywordToCollectionMapping: wlKeywordToCollectionMapping , enableSearchAlgoABTesting ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalData */ .U5)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const searchHistoryKey = "".concat(isMobile ? "MOBILE" : "DESKTOP", "_SEARCH_HISTORY");
    const initKeyword = router.query.query || "";
    const { onAddSingleItem , onRequestItemSku  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useCartV2 */ .T6)();
    const { getSearchAlgoFromCookie  } = (0,_useSearchAlgo__WEBPACK_IMPORTED_MODULE_5__/* .useSearchAlgo */ .t)();
    const { 0: keyword , 1: setKeyword  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initKeyword);
    const { 0: histories , 1: setHistories  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const { result: suggestions , isSuggestProduct  } = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useKeywords */ .N)(keyword, limitKeywords);
    // https://jira.teko.vn/browse/UX4BUYER-5849
    const keywordToCollectionMapping = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        const mapping = new Map(wlKeywordToCollectionMapping);
        return mapping;
    }, [
        wlKeywordToCollectionMapping
    ]);
    const getSearchHistory = function() {
        let count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
        if (typeof localStorage !== "undefined") {
            const historyStorage = localStorage.getItem(searchHistoryKey);
            if (historyStorage) {
                const data = JSON.parse(historyStorage);
                return (data || []).reverse().splice(0, count);
            }
            return [];
        }
        return [];
    };
    const saveSearchHistory = (keyword)=>{
        if (!keyword) return;
        const historyStorage = localStorage.getItem(searchHistoryKey);
        if (!historyStorage) {
            localStorage.setItem(searchHistoryKey, JSON.stringify([
                keyword
            ]));
            return;
        }
        let historyArr = JSON.parse(historyStorage);
        historyArr = historyArr.filter((item)=>JSON.stringify(item) !== JSON.stringify(keyword));
        historyArr = [
            ...historyArr,
            keyword
        ];
        localStorage.setItem(searchHistoryKey, JSON.stringify(historyArr));
        setHistories(getSearchHistory(numberOfHistories));
    };
    const removeSearchHistories = ()=>{
        if (typeof localStorage !== "undefined") {
            localStorage.setItem(searchHistoryKey, JSON.stringify([]));
            setHistories([]);
        }
    };
    const onSearch = (keywordObj)=>{
        const searchKeyword = keywordObj.query;
        saveSearchHistory(keywordObj);
        // if mapping contain keyword, go to that collection
        const normalizedKeyword = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalizeText */ .b)(searchKeyword, false);
        const localSearchAlgo = getSearchAlgoFromCookie();
        if (keywordToCollectionMapping.size && keywordToCollectionMapping.has(normalizedKeyword)) {
            const destination = keywordToCollectionMapping.get(normalizedKeyword);
            router.push(destination).then(()=>{
                window.scrollTo(0, 0);
            });
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .trackSearchEvent */ .q)(searchKeyword || "");
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .trackManually */ .gu)("searchButton", "headerBar", "searchProductResult", JSON.stringify({
                searchKeyword,
                href: window.location.href,
                url: window.location.origin + destination
            }));
        } else {
            // keep searching flow as usual
            const targetPath = {
                pathname: "/search",
                query: {
                    router: "productListing",
                    query: searchKeyword
                }
            };
            const targetAsPath = _objectSpreadProps(_objectSpread({}, targetPath), {
                query: (0,querystring__WEBPACK_IMPORTED_MODULE_1__.encode)(targetPath.query)
            });
            if (router.query.query) {
                router.replace(targetPath, targetAsPath);
            } else {
                router.push(targetPath, targetAsPath);
            }
            const targetUrl = new URL(window.location.origin);
            targetUrl.pathname = targetPath.pathname;
            targetUrl.search = new URLSearchParams(targetPath.query).toString();
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .trackSearchEvent */ .q)(searchKeyword || "", // if flag enableSearchAlgoABTesting===true --> send search algo version in tracking event
            !!enableSearchAlgoABTesting ? JSON.stringify({
                searchAlgorithm: !!localSearchAlgo ? localSearchAlgo.replace(constants_index__WEBPACK_IMPORTED_MODULE_10__/* .SEARCH_ALGO.REPLACE_PATTERN */ .XH.REPLACE_PATTERN, "") : localSearchAlgo
            }) : undefined);
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .trackManually */ .gu)("searchButton", "headerBar", "searchProductResult", JSON.stringify({
                searchKeyword,
                href: window.location.href,
                url: targetUrl.href
            }));
        }
    };
    const addToCart = async function(product) {
        let quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        if (!!product.sku) {
            await onAddSingleItem(// should pass product.sellerSku but api get keyword (discovery) hasn't returned sellerSku yet
            {
                sku: product.sku,
                sellerSku: product.sku,
                quantity
            }, true);
        } else if (!!product.highlight) {
            await onRequestItemSku(product.highlight, quantity);
        }
    };
    const onRedirectDetailProduct = (sku)=>{
        if (sku) {
            router.push("/products/".concat(sku));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (numberOfHistories > 0) {
            setHistories(getSearchHistory(numberOfHistories));
        } else setHistories([]);
    }, [
        numberOfHistories
    ]);
    return {
        keyword,
        setKeyword,
        histories,
        removeSearchHistories,
        suggestions: suggestions,
        onSearch,
        onRedirectDetailProduct,
        isSuggestProduct,
        addToCart
    };
};


/***/ }),

/***/ 967438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ trackSearchOrderEvent; },
/* harmony export */   "q": function() { return /* binding */ trackSearchEvent; }
/* harmony export */ });
/* harmony import */ var _helper_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(428247);


const trackSearchEvent = (keyword, params) => {
  var _a;
  window.track("siteSearch", {
    params: !!params ? params : "{}",
    keywords: keyword
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "view_search_results",
    content_keyword: keyword
  });
};
const trackSearchOrderEvent = ({
  eventName,
  category,
  keyword
}) => {
  return (0,_helper_es_js__WEBPACK_IMPORTED_MODULE_0__/* .trackCustomEvent */ .I)(eventName, {
    label: keyword,
    category
  });
};




/***/ })

}]);